import React from "react";
import { ResetPassword } from "../../../components";

export const ResetPasswordPage = () => {
  return <ResetPassword />;
};
